/**
 * @author michalstolarski
 * @since 2024-5-16
 */

import React from "react";
import { useTheme } from "styled-components";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { Props } from "./DatatransSecureField.types";
import * as Styled from "./DatatransSecureField.styled";

export const DatatransSecureField: React.FC<Props> = (
  props,
): React.ReactElement => {
  const theme = useTheme();
  const fallbackId = React.useId();

  const fieldId = props.id || fallbackId;

  return (
    <TestWrapper testId={props.testId}>
      <div className={props.className}>
        <Styled.Root
          htmlFor={fieldId}
          $focused={props.focused}
          $touched={props.touched}
          $disabled={props.disabled}
          hasError={!!props.error}
        >
          <Styled.Container hasIcon={!!props.icon}>
            <Styled.InputWrapper>
              <Styled.Label $touched={props.touched}>
                {props.label}
              </Styled.Label>
              {!!props.children &&
                React.Children.map(props.children, child => {
                  if (child.type !== "input") return child;

                  return React.cloneElement(child as React.ReactElement, {
                    id: fieldId,
                  });
                })}
            </Styled.InputWrapper>

            {props.icon && <props.icon width={theme.icons.sizes.base_x3} />}
          </Styled.Container>
        </Styled.Root>

        {!!props.error && <Styled.Error>{props.error}</Styled.Error>}
      </div>
    </TestWrapper>
  );
};
